export const removeNumberFormat = (value: string) => value.replace(/\D/g, '')
